import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const faqKeys = ['seo_vs_ads', 'which_companies', 'time_invest', 'contract_terms', 'get_started'] as const;

const FAQItem = ({
  question,
  answer,
  isOpen,
  onToggle,
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) => {
  return (
    <div className={`border-b border-gray-200 transition-colors ${isOpen ? 'border-emerald-200' : ''}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between py-6 text-left group"
        aria-expanded={isOpen}
      >
        <span className={`text-lg font-semibold pr-8 transition-colors ${isOpen ? 'text-emerald-700' : 'text-gray-900 group-hover:text-emerald-600'}`}>
          {question}
        </span>
        <span className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${
          isOpen ? 'bg-emerald-500 rotate-180' : 'bg-gray-100 group-hover:bg-emerald-50'
        }`}>
          <ChevronDown className={`w-5 h-5 transition-colors ${isOpen ? 'text-white' : 'text-gray-500'}`} />
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 pb-6' : 'max-h-0'
        }`}
      >
        <p className="text-gray-600 leading-relaxed pr-16">
          {answer}
        </p>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);
  const { t } = useTranslation();

  return (
    <section id="faq" className="py-24 md:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-widest text-emerald-600 uppercase mb-4">
            {t('simonsMarketing.faq.badge')}
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">
            {t('simonsMarketing.faq.title_start')}{' '}
            <span className="font-extrabold">{t('simonsMarketing.faq.title_bold')}</span>
          </h2>
        </div>

        <div className="border-t border-gray-200">
          {faqKeys.map((key, index) => (
            <FAQItem
              key={key}
              question={t(`simonsMarketing.faq.items.${key}.question`)}
              answer={t(`simonsMarketing.faq.items.${key}.answer`)}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
